import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Trash2 } from "lucide-react";

export const PostsTab = ({ posts, onDelete }) => (
  <Card className="bg-card border-border">
    <CardHeader>
      <CardTitle>Community Posts Moderation</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="space-y-4">
        {posts.map((post) => (
          <div key={post.post_id} className="p-4 bg-muted/20 rounded-lg">
            <div className="flex items-start justify-between">
              <div>
                <p className="font-medium">{post.user_name}</p>
                <p className="text-sm text-muted-foreground mt-1">{post.content}</p>
                <p className="text-xs text-muted-foreground mt-2">
                  {new Date(post.created_at).toLocaleString()}
                </p>
              </div>
              <Button size="sm" variant="ghost" className="text-red-400 hover:text-red-300" onClick={() => onDelete(post.post_id)}>
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          </div>
        ))}
        {posts.length === 0 && (
          <p className="text-center text-muted-foreground py-8">No posts yet</p>
        )}
      </div>
    </CardContent>
  </Card>
);

export const ReviewsTab = ({ reviews, onDelete }) => (
  <Card className="bg-card border-border">
    <CardHeader>
      <CardTitle>Reviews Moderation</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="space-y-4">
        {reviews.map((review) => (
          <div key={review.review_id} className="p-4 bg-muted/20 rounded-lg">
            <div className="flex items-start justify-between">
              <div>
                <p className="font-medium">{review.user_name}</p>
                <div className="flex gap-4 text-sm text-muted-foreground mt-1">
                  <span>Food: {review.food_rating}/5</span>
                  <span>Service: {review.service_rating}/5</span>
                  <span>Ambiance: {review.ambiance_rating}/5</span>
                </div>
                {review.comment && (
                  <p className="text-sm mt-2">{review.comment}</p>
                )}
                <p className="text-xs text-muted-foreground mt-2">
                  {new Date(review.created_at).toLocaleString()}
                </p>
              </div>
              <Button size="sm" variant="ghost" className="text-red-400 hover:text-red-300" onClick={() => onDelete(review.review_id)}>
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          </div>
        ))}
        {reviews.length === 0 && (
          <p className="text-center text-muted-foreground py-8">No reviews yet</p>
        )}
      </div>
    </CardContent>
  </Card>
);
